/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  createContext,
  FC,
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { useI18nContext } from '@/i18n/I18n';
import { getCaptchaConfig, getRealCookieConfig } from '@/services/user';
import { DEFAULT_CAPTCHA_CONFIG } from '@/utils/constants/common';
import { SUB_ACCOUNT_LOGIN_CAPTCHA_SCENE } from '@/utils/constants/sub-account';

const Captcha = lazy(() => import('@/safe/components/ByCaptcha'));

interface IGlobalContext {
  [key: string]: any;
}
interface IGlobalProvider {
  children: any;
}
export enum CaptchaType {
  GT = 'geecaptcha',
  QQ = 'qqcatpcha',
  GOOGLE = 'recaptcha',
}
interface ICookieConfig {
  completelyUseMagpieCatcha: boolean;
  useDowngrade: boolean;
  guidTailList: string[];
  oldCapchaList: CaptchaType[];
}
const globalContext = createContext<IGlobalContext>({});

const Provider = globalContext.Provider;
globalContext.displayName = 'subAccountLoginProvider';

let cookieRealConfig: any;
export const SubAccountLoginProvider: FC<IGlobalProvider> = ({ children }) => {
  const [$ti] = useTranslation('inverse');
  const [$te] = useTranslation('inverse-error-code');
  const [, lang] = useI18nContext();
  const [loaded, setLoaded] = useState(false);

  const [cookieConfig, setCookieConfig] = useState<{
    [key: string]: ICookieConfig;
  }>();
  const newCaptchaRef = useRef<any>();

  const $tFn = (key: string) => {
    if ($ti(key) !== key) {
      return $ti(key);
    }
    if ($te(key) !== key) {
      return $te(key);
    }
    return key;
  };

  const newCallVerifyComp = useCallback(
    (fn: (res: any) => void) => {
      if (window.disabledGoogleCaptcha) {
        return;
      }
      document
        .querySelectorAll(`iframe[src^="https://www.google.com/recaptcha"]`)
        .forEach((node: Element, key: number) => {
          node.parentElement?.classList.add('custom-google-2fa-modal');
        });
      newCaptchaRef?.current?.show(fn);
    },
    [newCaptchaRef],
  );

  useEffect(() => {
    if (!cookieConfig) {
      getCaptchaConfig().then((cookieConfig: any) => {
        cookieRealConfig = cookieConfig;
        setCookieConfig(cookieConfig);
      });
      setTimeout(() => {
        if (!cookieRealConfig) {
          setCookieConfig(getRealCookieConfig(DEFAULT_CAPTCHA_CONFIG));
        }
      }, 2000);
    }
  }, []);

  return (
    <Provider
      value={{
        $tFn,
        newCallVerifyComp,
        cookieConfig,
        loadCaptcha: () => {
          setLoaded(true);
        },
      }}
    >
      <Suspense fallback="">
        {loaded && (
          <>
            {cookieConfig && (
              <Captcha
                key="new"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //  @ts-ignore
                ref={newCaptchaRef}
                invisibleMode={true}
                plugins={
                  cookieConfig?.[SUB_ACCOUNT_LOGIN_CAPTCHA_SCENE]
                    ?.oldCapchaList || ['qqcaptcha']
                }
                lang={lang || 'en'}
              />
            )}
          </>
        )}
      </Suspense>
      {children}
    </Provider>
  );
};

export function useStore() {
  return useContext(globalContext);
}
